import React from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MisReportCard from "./MisReportCard";
import MainSidebar from "../../../Layout/MainSidebar";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
import { useUser } from "../../../context/AuthContext";

const Index = () => {
  const { user }= useUser();
  return (
    <MainDashboardLayout sidebar={user?.groupManager ? <GroupAdminSidebar/> :<MainSidebar />}>
      <Unauthorized requiredModule="MIS Reports">
        <MisReportCard />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Index;